fragment FullWidthBrandFragment on fullWidthBrand_Entry {
  id
  typeHandle
  heading
  images {
    url
    title
  }
}
